import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

export const API_BASE_URL = new InjectionToken<string>('PV_API_BASE_URL');

export function provideApiBaseUrl(baseUrl: string): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: API_BASE_URL, useValue: baseUrl }]);
}
